export default __webpack_public_path__ + "static/media/bgImg.3e06573d.png";